import React, { useLayoutEffect, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import LockUnlock from "../App/LockUnlock";
import ConfirmationModal from "../App/ConfirmationModal";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import {
  DownloadClientsDataInExcel,
  GetRefindURLPage,
  GetThumbnailImage,
  SortTheList,
} from "../Shared/Utility";
import ContentLibrary from "./ContentLibrary";
import LockUnlockV2 from "../App/LockUnlockV2";
import ProductFaqs from "./ProductFaqs";
import QuillEditor from "../QuillEditor";

function ProductCategory() {
  const globalState = useGlobalState();
  const [showAnimation, setShowAnimation] = useState(false);
  const [objectAdminData, setObjectAdminData] = useState<any>([]);
  const [editMode, setEditMode] = useState(0);
  const [showOrders, setShowOrders] = useState(false);
  const [locked, setLocked] = useState(true);

  const [showOrdersImages, setShowOrdersImages] = useState(false);
  const [lockedImages, setLockedImages] = useState(true);

  const [selectedStatus, setSelectedStatus] = useState(1);
  const [type, setType] = useState(10);
  const [showContentLibraryModal, setShowContentLibraryModal] = useState(false);
  const [imagesData, setImagesData] = useState<any>([]);
  const [informationTab, setInformationTab] = useState(1);
  const [addEditObject, setAddEditObject] = useState({
    PTProductCategoryID: 0,
    CatId: 0,
    Name: "",
    Description: "",
    ShortDescription: "",
    URLFriendlyName: "",
    MainImageURL: "",
    ThumbnailURL: "",
    MetaKeyswords: "",
    MetaTitle: "",
    MetaDescription: "",
    PTOrderBy: 0,
    VisibilityStatus: 0,
    Binder: "",
    Filter: "",
    ParentID: 0,
    Strength: 0,
    Wrapper: "",
    ObjectSchema: "",
  });

  useEffect(() => {
    getObjectAdminData(0, 0);
  }, [selectedStatus]);

  function getObjectAdminData(add: any, pid: any) {
    let object = {} as any;
    object.type = type;
    object.add = add;
    object.pid = pid;
    object.status = selectedStatus;
    setShowAnimation(true);
    setEditMode(0);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetProductAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          setObjectAdminData(l_response[0]);
          const deepCopy1 = JSON.parse(JSON.stringify(l_response));
          const deepCopy2 = JSON.parse(JSON.stringify(l_response));
          setThisGridListDataWithoutFilters(deepCopy1);
          //setObjectAdminData(deepCopy1[0]);
          setThisGridListData(deepCopy2[0]);
          thisGridListDataRef.current = deepCopy2[0];
        } else {
          console.log("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function addNewRecord() {
    setAddEditObject({
      PTProductCategoryID: 0,
      CatId: 0,
      Name: "",
      Description: "",
      ShortDescription: "",
      URLFriendlyName: "",
      MainImageURL: "",
      ThumbnailURL: "",
      MetaKeyswords: "",
      MetaTitle: "",
      MetaDescription: "",
      PTOrderBy: 0,
      VisibilityStatus: 0,
      Binder: "",
      Filter: "",
      ParentID: 0,
      Strength: 0,
      Wrapper: "",
      ObjectSchema: "",
    });

    setEditMode(1);
    setInformationTab(1);
  }

  function getDataForEdit(add: any, pid: any, reload = true) {
    let object = {} as any;
    object.type = type;
    object.add = add;
    object.pid = pid;
    object.status = selectedStatus;
    setShowAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetProductAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          setAddEditObject(l_response[0][0]);
          setImagesData(l_response[1]);
          if (reload == true) {
            setEditMode(2);
            setInformationTab(1);
          }
        } else {
          console.log("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValue(value: any, index: any, colName: string) {
    let thisobjectAdminData: any = [...thisGridListData];
    thisobjectAdminData[index][colName] = value;
    setObjectAdminData(thisobjectAdminData);
  }
  function updateValueImages(value: any, index: any, colName: string) {
    let thisobjectAdminData: any = [...imagesData];
    thisobjectAdminData[index][colName] = value;
    setImagesData(thisobjectAdminData);
  }

  function checkValidation(
    typeid: any,
    pid: any,
    colvalue: string,
    colname: any,
  ) {
    let isOkayToGo = true;
    if (addEditObject.Name == "") {
      isOkayToGo = false;
    }
    if (isOkayToGo == false) {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Please enter name",
      });
    } else {
      updateObjectAdminData(typeid, pid, colvalue, colname);
    }
  }

  function updateObjectAdminData(
    typeid: any,
    pid: any,
    colvalue: string,
    colname: any,
  ) {
    let object = {} as any;
    object.type = typeid;
    object.pid = pid;
    object.colname = colname;
    object.colvalue = colvalue;
    object.catid = addEditObject.CatId;
    object.name = typeid == 20 ? "" : addEditObject.Name;
    object.description = addEditObject.Description;
    object.ufurl = addEditObject.URLFriendlyName;
    object.visibilitystatus = addEditObject.VisibilityStatus;
    object.ordering = addEditObject.PTOrderBy;
    object.strength = addEditObject.Strength;
    object.shortdescription = addEditObject.ShortDescription;
    object.th = addEditObject.ThumbnailURL;
    object.main = addEditObject.MainImageURL;
    object.wrapper = addEditObject.Wrapper;
    object.binder = addEditObject.Binder;
    object.filter = addEditObject.Filter;
    object.metatitle = addEditObject.MetaTitle;
    object.metakeyswords = addEditObject.MetaKeyswords;
    object.metadescription = addEditObject.MetaDescription;

    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/UpdateProductAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data[0][0];
          if (l_response.Status == 1) {
            if (typeid == 20) {
              if (colname != "Name" && colname != "imgsrc")
                getDataForEdit(0, addEditObject.PTProductCategoryID, false);
            } else if (colname != "VisibilityStatus" && colname != "ObjectSchema") {
              getObjectAdminData(0, 0);
            }
          } else {
            globalState.setNotificationObject({
              ShowPopup: true,
              Heading: "Alert",
              Message: l_response.Message,
            });
          }
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(15, obj.SelectedID, "", "del");
      }
    }
    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(20, obj.SelectedID, "", "delimage");
      }
    }

    if (obj.ID === 100) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "archive");
      }
    }

    if (obj.ID === 101) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "undoarchive");
      }
    }

    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    //setObjectAdminData(deepCopy[0]);
    setThisGridListData(deepCopy[0]);
    // thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage(); // Called after DOM update but before paint
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSortName")) {
        (document.getElementById("imgSortName") as HTMLInputElement).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function setURLFriendlyName(name: string) {
    let URLFriendlyName = GetRefindURLPage(name);

    setAddEditObject((prevState: any) => ({
      ...prevState,
      URLFriendlyName: URLFriendlyName,
    }));
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />
      {objectAdminData && objectAdminData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={objectAdminData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {showAnimation && <LoadingAnimation />}

      {/* <div className="page--breadcrumb flex-jsb">
          <a>Product Category</a>
        </div> */}

      <div className="flex-d justify-btw mb-10">
        {/* {editMode == false && (
                <select
                  value={selectedStatus}
                  onChange={(e: any) => setSelectedStatus(e.target.value)}
                >
                  <option value="0">All</option>
                  <option value="1">Active</option>
                  <option value="2">Archived</option>
                </select>
              )} */}
        {/* <span></span> */}
        <span></span>
        {editMode == 0 && (
          <div className="flex-daj flex-gap10">
            <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a>
            {locked == false && (
              <>
                <div className="com-toggle">
                  <span className="txt-compare bold-font">Show Order</span>

                  <a
                    className={showOrders ? "com-btn com-sel" : "com-btn"}
                    onClick={() => {
                      setShowOrders(!showOrders);
                    }}
                  >
                    <span></span>
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => addNewRecord()}
                  >
                    Add New
                  </a>
                </div>
              </>
            )}

            <a
              className="btn-primary flex-daj btn-grid no-display"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel("tblprodcat", "Product Categories")
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>

            <LockUnlockV2 locked={locked} setLocked={setLocked} />
          </div>
        )}
      </div>

      {editMode == 0 && (
        <div className="flow-auto">
          <table className="reuse-table" id="tblprodcat">
            <thead>
              <tr>
                <th className="td-md">
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Name
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "Name")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("Name")}
                        title="Sort By Name"
                      >
                        <span id="imgSortName">
                          <img
                            src="images/none.svg"
                            width="10px"
                            height="13px"
                            alt="B"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>Description</th>

                <th className="td-xxs">Visibility</th>
                {/* <th className="reused-tdxs sticky-header">Ordering</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td className="p-all0">
                          <input
                            disabled={true}
                            value={item.Name}
                            onChange={(e) =>
                              updateValue(e.target.value, index, "Name")
                            }
                            onBlur={(e) =>
                              updateObjectAdminData(
                                type,
                                item.PID,
                                e.target.value,
                                "Name",
                              )
                            }
                            className="text-left"
                          />
                        </td>
                        <td className="p-all0">
                          <input
                            disabled={true}
                            value={item.Description}
                            // onChange={(e) =>
                            //   updateValue(
                            //     e.target.value,
                            //     index,
                            //     "Description",
                            //   )
                            // }
                            // onBlur={(e) =>
                            //   updateObjectAdminData(
                            //     type,
                            //     item.PID,
                            //     e.target.value,
                            //     "Description",
                            //     [],
                            //   )
                            // }
                            className="text-left"
                          />
                        </td>
                        <td className="p-all0">
                          <select
                            disabled={true}
                            value={item.VisibilityStatus}
                            // onChange={(e) => {
                            //   updateValue(
                            //     e.target.value,
                            //     index,
                            //     "VisibilityStatus",
                            //   );
                            //   updateObjectAdminData(
                            //     15,
                            //     item.PID,
                            //     e.target.value,
                            //     "VisibilityStatus",
                            //   );
                            // }}
                            className="text-left"
                          >
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </td>
                        {/* <td className="text-center">
                                <div className="flex-d flex-jc flex-gap10">
                                  <button
                                    className="p-all0 no-bg no-border cursor-p"
                                    disabled={
                                      index == 0 || locked ? true : false
                                    }
                                    title="Up"
                                    onClick={(e) =>
                                      updateObjectAdminData(
                                        15,
                                        item.PID,
                                        "up",
                                        "PTOrderBy",
                                      )
                                    }
                                  >
                                    <img
                                      src="images/o-up.svg"
                                      width="14px"
                                      height="16px"
                                      alt="up"
                                    />
                                  </button>
                                  <button
                                    className="p-all0 no-bg no-border cursor-p"
                                    disabled={
                                      index == thisGridListData.length - 1 ||
                                      locked
                                        ? true
                                        : false
                                    }
                                    title="Down"
                                    onClick={(e) =>
                                      updateObjectAdminData(
                                        15,
                                        item.PID,
                                        "down",
                                        "PTOrderBy",
                                      )
                                    }
                                  >
                                    <img
                                      src="images/o-down.svg"
                                      width="14px"
                                      height="16px"
                                      alt="down"
                                    />
                                  </button>

                                  {showOrders && (
                                    <>
                                      <input
                                        className="text-right"
                                        disabled={locked}
                                        value={item.PTOrderBy}
                                        onChange={(e) =>
                                          updateValue(
                                            e.target.value,
                                            index,
                                            "PTOrderBy",
                                          )
                                        }
                                        onBlur={(e) =>
                                          updateObjectAdminData(
                                            15,
                                            item.PID,
                                            e.target.value,
                                            "PTOrderBy",
                                          )
                                        }
                                      />
                                    </>
                                  )}
                                </div>
                              </td> */}
                        <td className="td-xxs">
                          <div className="flex-daj gap-10">
                            <button
                              title="Edit"
                              className="no-borbg cursor-p"
                              disabled={locked}
                              onClick={() => getDataForEdit(0, item.PID)}
                            >
                              <img
                                src="images/edit.svg"
                                width="17px"
                                height="17px"
                                alt="Edit"
                              />
                            </button>
                            <button
                              title="Delete"
                              className="no-borbg cursor-p"
                              disabled={locked}
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID: item.PID,
                                  OtherID: 0,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="17px"
                                height="17px"
                                alt="Edit"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {editMode > 0 && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <div className="flex-da justify-btw mb-10">
            <h3 className="font-16 bold-font m-0">
              {editMode == 1 ? "Add New Category" : "Update Category"}
            </h3>
            {editMode == 2 && (
              <div className="copy-tab copy-tab2">
                <a
                  onClick={() => setInformationTab(1)}
                  className={`name-count ${
                    informationTab === 1 ? "selected" : ""
                  }`}
                >
                  Information
                </a>

                {/* <a
                style={{borderLeft:"1px solid #64278c"}}
                  className={`flex-daj ${
                    informationTab === 2 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(2)}
                >
                  Images
                </a> */}
                <a
                  className={`name-count ${
                    informationTab === 4 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(4)}
                >
                  Product Schema
                </a>
                <a
                  style={{ borderLeft: "1px solid #64278c" }}
                  className={`name-count ${
                    informationTab === 3 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(3)}
                >
                  FAQs
                </a>
              </div>
            )}
          </div>

          {informationTab == 1 && (
            <>
              <div className="grid-d fr-111 gap-20 flex-as">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">Name:</span>
                  <input
                    className="input-field w-100"
                    value={addEditObject.Name}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        Name: e.target.value,
                      }))
                    }
                    onBlur={(e) => setURLFriendlyName(e.target.value)}
                  />
                </div>
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    URL Friendly Name:
                  </span>
                  <input
                    className="input-field w-100"
                    value={addEditObject.URLFriendlyName}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        URLFriendlyName: e.target.value,
                      }))
                    }
                    onBlur={(e) => setURLFriendlyName(e.target.value)}
                  />
                </div>

                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Visibility:
                  </span>
                  <select
                    className="input-field w-100"
                    value={addEditObject.VisibilityStatus}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        VisibilityStatus: e.target.value,
                      }))
                    }
                  >
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>
                </div>
              </div>

              <div className="grid-d fr-1 mt-20 gap-20">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Description:
                  </span>
                  {/* <textarea
                              className="input-field w-100 p-all10"
                              style={{ height: "120px" }}
                              value={addEditObject.Description}
                              onChange={(e) =>
                                setAddEditObject((prevState: any) => ({
                                  ...prevState,
                                  Description: e.target.value,
                                }))
                              }
                            /> */}

                  <div className="ck-editor-container">
                    <QuillEditor
                      value={addEditObject.Description}
                      onChange={(value: string) =>
                        setAddEditObject((prev: any) => ({
                          ...prev,
                          Description: value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Short Description:
                  </span>
                  {/* <textarea
                              className="input-field w-100 p-all10"
                              style={{ height: "120px" }}
                              value={addEditObject.ShortDescription}
                              onChange={(e) =>
                                setAddEditObject((prevState: any) => ({
                                  ...prevState,
                                  ShortDescription: e.target.value,
                                }))
                              }
                            /> */}

                  <div className="ck-editor-container">
                    <QuillEditor
                      value={addEditObject.ShortDescription}
                      onChange={(value: string) =>
                        setAddEditObject((prev: any) => ({
                          ...prev,
                          ShortDescription: value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="grid-d fr-111 gap-20 mt-20 flex-as">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color flex-da flex-gap5">
                    Main Image:{" "}
                    <a
                      title="Manage Content Library"
                      className="flex-d library-btn"
                      onClick={() => setShowContentLibraryModal(true)}
                    >
                      <img
                        src="images/m-manage.svg"
                        width="18px"
                        height="18px"
                        alt="Edit"
                      />
                    </a>
                  </span>
                  <input
                    className="input-field w-100"
                    value={addEditObject.MainImageURL}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        MainImageURL: e.target.value,
                      }))
                    }
                  />
                  {addEditObject.MainImageURL != "" && (
                    <div className="contact-attachments">
                      <div className="remove--image">
                        <img
                          src={GetThumbnailImage(addEditObject.MainImageURL)}
                          alt="img"
                          width="200"
                          height="100"
                          style={{ width: "auto" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color flex-da flex-gap5">
                    Thumbnail Image:{" "}
                    <a
                      title="Manage Content Library"
                      className="flex-d library-btn"
                      onClick={() => setShowContentLibraryModal(true)}
                    >
                      <img
                        src="images/m-manage.svg"
                        width="18px"
                        height="18px"
                        alt="Edit"
                      />
                    </a>
                  </span>
                  <input
                    className="input-field w-100"
                    value={addEditObject.ThumbnailURL}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        ThumbnailURL: e.target.value,
                      }))
                    }
                  />
                  {addEditObject.ThumbnailURL != "" && (
                    <div className="contact-attachments">
                      <div className="remove--image">
                        <img
                          src={GetThumbnailImage(addEditObject.ThumbnailURL)}
                          alt="img"
                          width="200"
                          height="100"
                          style={{ width: "auto" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="grid-d fr-111 gap-20 mt-20 flex-as">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Meta Title:
                  </span>
                  <input
                    className="input-field w-100"
                    value={addEditObject.MetaTitle}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        MetaTitle: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Meta Description:
                  </span>
                  <textarea
                    className="input-field w-100"
                    value={addEditObject.MetaDescription}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        MetaDescription: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Meta Keyswords:
                  </span>
                  <textarea
                    className="input-field w-100"
                    value={addEditObject.MetaKeyswords}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        MetaKeyswords: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="flex-daj gap-10 mt-20">
                {editMode == 1 && (
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => checkValidation(10, 0, "", "")}
                    >
                      Save
                    </a>
                  </div>
                )}
                {editMode == 2 && (
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() =>
                        checkValidation(
                          10,
                          addEditObject.PTProductCategoryID,
                          "",
                          "",
                        )
                      }
                    >
                      Update
                    </a>
                  </div>
                )}
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setEditMode(0)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </>
          )}

          {informationTab == 2 && (
            <>
              <div className="flex-d justify-btw mb-10 mt-20">
                <span></span>
                <div className="flex-daj flex-gap10">
                  {lockedImages == false && (
                    <>
                      <div className="com-toggle">
                        <span className="txt-compare bold-font">
                          Show Order
                        </span>

                        <a
                          className={
                            showOrdersImages ? "com-btn com-sel" : "com-btn"
                          }
                          onClick={() => {
                            setShowOrdersImages(!showOrdersImages);
                          }}
                        >
                          <span></span>
                        </a>
                      </div>
                      <div className="flex-daj btn-start">
                        <a
                          className="btn-primary flex-daj"
                          onClick={() =>
                            updateObjectAdminData(
                              20,
                              addEditObject.PTProductCategoryID,
                              "",
                              "addimage",
                            )
                          }
                        >
                          Add New
                        </a>
                      </div>
                    </>
                  )}

                  <LockUnlockV2
                    locked={lockedImages}
                    setLocked={setLockedImages}
                  />
                </div>
              </div>
              <div className="flow-auto">
                <table className="reuse-table" id="tblprodcat">
                  <thead>
                    <tr>
                      <th className="td-md">Name</th>
                      <th>
                        <div className="flex-daj flex-gap10">
                          Image Path
                          <a
                            title="Manage Content Library"
                            className="flex-d library-btn"
                            onClick={() => setShowContentLibraryModal(true)}
                          >
                            <img
                              src="images/m-manage.svg"
                              width="18px"
                              height="18px"
                              alt="Edit"
                            />
                          </a>
                        </div>
                      </th>
                      <th className="td-xs">Preview</th>
                      <th className="td-xxs">Ordering</th>
                      <th className="td-xxs">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {imagesData &&
                      imagesData.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td className="p-all0">
                              <input
                                disabled={lockedImages}
                                value={item.Name}
                                onChange={(e) =>
                                  updateValueImages(
                                    e.target.value,
                                    index,
                                    "Name",
                                  )
                                }
                                onBlur={(e) =>
                                  updateObjectAdminData(
                                    20,
                                    item.PTProductCategoryFilesID,
                                    e.target.value,
                                    "Name",
                                  )
                                }
                                className="text-left"
                              />
                            </td>
                            <td className="p-all0">
                              <input
                                disabled={lockedImages}
                                value={item.FilePath}
                                onChange={(e) =>
                                  updateValueImages(
                                    e.target.value,
                                    index,
                                    "FilePath",
                                  )
                                }
                                onBlur={(e) =>
                                  updateObjectAdminData(
                                    20,
                                    item.PTProductCategoryFilesID,
                                    e.target.value,
                                    "imgsrc",
                                  )
                                }
                                className="text-left"
                              />
                            </td>
                            <td className="p-all5">
                              {item.FilePath != "" && (
                                <div className="flex-daj">
                                  <div className="contact-attachments m-0">
                                    <div className="remove--image">
                                      <img
                                        src={GetThumbnailImage(item.FilePath)}
                                        alt="img"
                                        width="150"
                                        height="50"
                                        style={{ width: "auto" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="flex-daj flex-gap10">
                                <button
                                  className="no-borbg pointer"
                                  disabled={
                                    index == 0 || lockedImages ? true : false
                                  }
                                  title="Up"
                                  onClick={(e) =>
                                    updateObjectAdminData(
                                      20,
                                      item.PTProductCategoryFilesID,
                                      "up",
                                      "PTOrderBy",
                                    )
                                  }
                                >
                                  <img
                                    src="images/o-up.svg"
                                    width="14px"
                                    height="16px"
                                    alt="up"
                                  />
                                </button>
                                <button
                                  className="no-borbg pointer"
                                  disabled={
                                    index == imagesData.length - 1 ||
                                    lockedImages
                                      ? true
                                      : false
                                  }
                                  title="Down"
                                  onClick={(e) =>
                                    updateObjectAdminData(
                                      20,
                                      item.PTProductCategoryFilesID,
                                      "down",
                                      "PTOrderBy",
                                    )
                                  }
                                >
                                  <img
                                    src="images/o-down.svg"
                                    width="14px"
                                    height="16px"
                                    alt="down"
                                  />
                                </button>

                                {showOrdersImages && (
                                  <>
                                    <input
                                      className="text-right"
                                      disabled={lockedImages}
                                      value={item.PTOrderBy}
                                      onChange={(e) =>
                                        updateValueImages(
                                          e.target.value,
                                          index,
                                          "PTOrderBy",
                                        )
                                      }
                                      onBlur={(e) =>
                                        updateObjectAdminData(
                                          20,
                                          item.PTProductCategoryFilesID,
                                          e.target.value,
                                          "PTOrderBy",
                                        )
                                      }
                                    />
                                  </>
                                )}
                              </div>
                            </td>
                            <td className="text-center">
                              <div className="flex-daj flex-gap10">
                                <button
                                  title="Delete"
                                  className="no-borbg pointer"
                                  disabled={lockedImages}
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 2,
                                      SelectedID: item.PTProductCategoryFilesID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="17px"
                                    height="17px"
                                    alt="Edit"
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setEditMode(0)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </>
          )}

          {informationTab == 3 && (
            <>
              <ProductFaqs Type={1} PID={addEditObject.PTProductCategoryID} />
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setEditMode(0)}
                >
                  Close
                </a>
              </div>
            </>
          )}

          {informationTab == 4 && (
            <>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Schema:</span>
                <textarea
                  className="input-field w-100 schema-notes"
                  value={addEditObject.ObjectSchema}
                  onChange={(e) => {
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectSchema: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="flex-daj btn-start gap-10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={(e) => {
                    updateObjectAdminData(
                      15,
                      addEditObject.PTProductCategoryID,
                      addEditObject.ObjectSchema,
                      "ObjectSchema",
                    );
                  }}
                >
                  Update
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setEditMode(0)}
                >
                  Back
                </a>
              </div>
            </>
          )}
        </div>
      )}

      {showContentLibraryModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup-content">
              <div className="help-head flex-da justify-btw">
                <h3 className="m-0 font-16 bold-font">Content Library</h3>
                <a
                  className="close-help"
                  onClick={() => setShowContentLibraryModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="mt-20 p-all0">
                <ContentLibrary />
              </div>
              <div className="flex-daj flex-gap10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowContentLibraryModal(false)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default ProductCategory;
